import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { withRouter } from 'react-router';
import { Filter, Main } from 'Containers/';
import { TitledCard } from 'Components/';
import * as _ from 'lodash';

import {
  getReimbursementRates,
  getAllSites,
  getReport,
  clearReport,
} from './state/report/actions';

import { ReimbursementReportForm } from './components/ReimbursementReportForm';
import { ReimbursementReportFieldEnum as Fields } from 'Common/FieldEnum';
import { REIMBURSEMENT_REPORT_FORM_NAME } from 'Common/FormEnum';
import moment from 'moment';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { SiteGrid } from '../reimbursement/components/SiteGrid';
import { toastType, createToast } from 'Common/ToastHelper';
import { ReportGeneration } from 'Common/ObjectHelper';

class ReimbursementReportContainer extends Component {
  componentDidMount() {
    this.props.getReimbursementRates();
    this.props.getAllSites();
  }

  componentDidUpdate(prevProps, prevState) {
    const { report, error } = this.props;

    if (error || _.isUndefined(error)) {
      createToast(toastType.error, 'Error', 'Error retrieving report!', true);
    } else {
      if (prevProps.report !== report && report) {
        if (report === 'No Data') {
          createToast(toastType.info, 'Results', 'No data found!', true);
        } else {
          ReportGeneration(report, 'Reimbursement Report');
        }
      }
    }
    this.props.clearReport();
  }

  getMainProps = () => {
    const { loading } = this.props;

    return {
      toolbox: {
        formName: REIMBURSEMENT_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: loading,
        },
        shown: true,
      },
    };
  };

  getInitialRate = () => {
    const { reimbursementRates } = this.props;
    let rValue = null;
    if (reimbursementRates) {
      if (reimbursementRates.length > 0) {
        rValue = reimbursementRates[0].Id;
      }
    }
    return rValue;
  };

  handleSubmit = formValues => {
    const data = { ...formValues, SelectedSites: this.props.selectedSites };

    if (data.SelectedSites && data.SelectedSites.length === 0) {
      return createToast(
        toastType.error,
        'Error',
        'Please select one or more sites to continue!',
        true
      );
    }

    this.props.getReport(data);
  };

  render() {
    return (
      <Fragment>
        {this.props.loading ? (
          <LoadingPage
            message={
              this.props.loading && this.props.loadingReport
                ? 'Loading Report'
                : 'Loading'
            }
          />
        ) : (
          undefined
        )}
        <Filter title={'Reimbursement'} />
        <Main {...this.getMainProps()}>
          <TitledCard>
            <ReimbursementReportForm
              onSubmit={this.handleSubmit}
              initialValues={{
                [Fields.ReimbursementType]: 0,
                [Fields.FeedingType]: 0,
                [Fields.FromDate]: defaultDateFormat(moment()),
                [Fields.ToDate]: defaultDateFormat(moment()),
                [Fields.ReimbursementRateId]: this.getInitialRate(),
              }}
            />
          </TitledCard>
          <SiteGrid data={this.props.sites} />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  //destructured

  const { report } = state.ReimbursementReportState;

  return {
    report: report.report,
    sites: report.sites,
    selectedSites: report.selectedSites,
    reimbursementRates: report.reimbursementRates,
    loading: report.loading,
    loadingReport: report.loadingReport,
    error: report.error,
  };
};

export const Reimbursement = withRouter(
  connect(
    mapStateToProps,
    {
      getReimbursementRates,
      getAllSites,
      getReport,
      clearReport,
    }
  )(ReimbursementReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/reimbursement/Reimbursement.js